import { jQueryStatic } from '../lib/jQuery';
export default class GetPage {
  /**
   * Get the url contents. Returns a promise for string of the data (ie html or JSON)
   */
  public async get(location: string): Promise<string> {
    const response = await jQueryStatic.get(location);
    return response;
  }
}
